exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-part__title h1[data-v-3df26761]{font-family:SFPro,Arial,sans-serif;font-size:65px;color:#000;line-height:1.2;font-weight:700}.header-part__title .header-link[data-v-3df26761]{font-family:SFPro,Arial,sans-serif;display:block;padding:24px 0;color:#00ba57!important;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3df26761","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/change/components/PolicyHeader.vue
// module id = 05XZ
// module chunks = 0